package games.polyclub.website.frontend.store.hooks

import games.polyclub.service.payment.api.Order
import games.polyclub.service.profile.api.PlayerProfile
import games.polyclub.service.store.api.Offer
import games.polyclub.tool.strings.Currency
import games.polyclub.tool.strings.Money.Companion.sumOfMoney
import kotlinx.serialization.json.*

fun Offer.Loaded.toGA4(currency: Currency, playerProfile: PlayerProfile?): JsonObject = buildJsonObject {
    //put("currency", currency.toString())
    //put("value", total(currency, playerProfile).amount.toDouble())
    put("promotion_id", id.value)
    putJsonArray("items") {
        products.forEach { product ->
            val basePrince = currency.amount(product.price)
            val discounts = discounts.filter { it.canBeAppliedTo(product.tags, basePrince, playerProfile) }
            val totalDiscount = discounts.sumOfMoney(currency) { it.applyTo(basePrince).reduction }
            val taxes = taxes.filter { it.canBeAppliedTo(product.tags, basePrince, playerProfile) }
            val totalTax = taxes.sumOfMoney(currency) { it.applyTo(basePrince).increase }
            addJsonObject {
                put("item_id", product.id.toString())
                put("item_name", product.name)
                put("price", (basePrince + totalTax).amount.toDouble())
                put("discount", totalDiscount.amount.toDouble())
                put("quantity", 1)
            }
        }
    }
}

fun Order.toGA4(): JsonObject = buildJsonObject {
    put("currency", total.currency.toString())
    put("value", total.amount.toDouble())
    putJsonArray("items") {
        products.forEach { product ->
            addJsonObject {
                put("item_id", product.productId.toString())
                put("item_name", product.productName)
                put("discount", product.discount.amount.toDouble())
                put("price", product.basePrince.amount.toDouble())
                put("quantity", product.quantity.toInt())
            }
        }
    }
}
